import { useEffect } from 'react';
interface SeoProps {
  title: string;
  description: string;
  path: string;
}
function upsertMeta(selector: string, attrs: Record<string, string>) {
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([key, value]) => el?.setAttribute(key, value));
}
function upsertLink(rel: string, attrs: Record<string, string>) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([key, value]) => el?.setAttribute(key, value));
}
const FAVICON_PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' fill='%23151d29'/%3E%3Ctext x='32' y='43' font-family='Inter,sans-serif' font-size='34' font-weight='600' fill='%23ffffff' text-anchor='middle'%3EF%3C/text%3E%3C/svg%3E";
export function Seo({
  title,
  description,
  path
}: SeoProps) {
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = 'en';
    upsertMeta('meta[name="description"]', {
      name: 'description',
      content: description
    });
    upsertMeta('meta[name="robots"]', {
      name: 'robots',
      content: 'index, follow'
    });
    upsertMeta('meta[property="og:title"]', {
      property: 'og:title',
      content: title
    });
    upsertMeta('meta[property="og:description"]', {
      property: 'og:description',
      content: description
    });
    upsertMeta('meta[property="og:type"]', {
      property: 'og:type',
      content: 'website'
    });
    upsertMeta('meta[property="og:site_name"]', {
      property: 'og:site_name',
      content: 'Futuramy Investment LLC'
    });
    upsertMeta('meta[property="og:url"]', {
      property: 'og:url',
      content: path
    });
    upsertMeta('meta[name="twitter:card"]', {
      name: 'twitter:card',
      content: 'summary_large_image'
    });
    upsertMeta('meta[name="twitter:title"]', {
      name: 'twitter:title',
      content: title
    });
    upsertMeta('meta[name="twitter:description"]', {
      name: 'twitter:description',
      content: description
    });
    upsertLink('canonical', {
      href: path
    });
    upsertLink('icon', {
      href: FAVICON_PLACEHOLDER,
      type: 'image/svg+xml'
    });
  }, [title, description, path]);
  return null;
}